import { ContextProvider } from "components/table/execute_report/Context";
import { Table } from "components/table/execute_report/Table";

const ExecuteReport = () => {
	return (
		<>
			<ContextProvider>
				<Table />
			</ContextProvider>
		</>
	);
};

export { ExecuteReport };
